/* Milestone metadata helpers — thin, generic lookups into the per-vertical
 * grading pack at src/seed/milestones.ts. No vertical-specific knowledge lives
 * here; retargeting to a new industry only touches the pack. */

import type { MilestoneTag, MomentType } from './types';
import { MILESTONES } from '@/seed/milestones';

/** Win vs growth for a milestone (the live classifier may still override per
 *  turn; this is the default from the vocabulary). Vulnerable-population
 *  inversions (did_not_oversell = win, failed_suitability = growth) are
 *  encoded in the pack, not here. */
export function defaultMomentType(tag: MilestoneTag): MomentType {
  return MILESTONES[tag].moment;
}

/** Default temperature_delta for a milestone (mock mode uses it directly; the
 *  live meta classifier may override). */
export function defaultTemperatureDelta(tag: MilestoneTag): number {
  return MILESTONES[tag].temperatureDelta;
}

/** Signed score contribution. composeVerdict() starts at 50, sums these,
 *  clamps 0..100. */
export function defaultMilestoneWeight(tag: MilestoneTag): number {
  return MILESTONES[tag].weight;
}

/** Short human label for the debrief moments list. */
export function milestoneLabel(tag: MilestoneTag): string {
  return MILESTONES[tag].label;
}
